// extracted by mini-css-extract-plugin
export default {"wrapper":"videoPlayer_wrapper__One9k"};